import { X } from "lucide-react";
import { FC } from "react";
import { CreateInventoryForm } from "./create-inventory-form";

interface CreateInventorySidebarProps {
  open: boolean;
  onClose: () => void;
}

export const CreateInventorySidebar: FC<CreateInventorySidebarProps> = ({
  open,
  onClose,
}) => {
  const handleSuccess = () => {
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed right-0 top-0 h-full bg-white border-l border-[#e5e5e5] z-50 overflow-y-auto w-full sm:w-[600px]">
      <div className="sticky top-0 bg-white border-b border-[#e5e5e5] p-4 flex items-center justify-between z-10">
        <div className="border border-[#e5e5e5] rounded-lg inline-block px-3 py-1">
          <h2 className="font-bold text-sm uppercase tracking-wide text-[#1a1a2e] !mb-0">
            Create Inventory
          </h2>
        </div>
        <button
          onClick={onClose}
          className="border border-[#e5e5e5] rounded-lg bg-white text-[#1a1a2e] p-2 hover:bg-[#fafafa] transition-all"
          aria-label="Close"
        >
          <X size={20} />
        </button>
      </div>
      <div className="p-4">
        <CreateInventoryForm onSuccess={handleSuccess} onCancel={onClose} />
      </div>
    </div>
  );
};


